import type { IGetCommentResponse } from '../../../api/types'

export function findCommentInTree(
  roots: IGetCommentResponse[],
  id: number,
): IGetCommentResponse | null {
  const walk = (node: IGetCommentResponse): IGetCommentResponse | null => {
    if (node.id === id) return node
    for (const child of node.children ?? []) {
      const found = walk(child)
      if (found) return found
    }
    return null
  }

  for (const root of roots) {
    const found = walk(root)
    if (found) return found
  }
  return null
}
